import {
  Heading as ChakraHeading,
  HeadingProps as ChakraHeadingProps,
  TypographyProps,
  defineStyleConfig
} from '@chakra-ui/react';
import { textStyles } from '../../../../theme/common';

export type HeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const variantsHandler: {
  [type in HeadingVariant]: {
    fontSize: TypographyProps['fontSize'];
    lineHeight: TypographyProps['lineHeight'];
    fontWeight?: TypographyProps['fontWeight'];
  };
} = {
  h1: {
    fontSize: '2.5rem',
    lineHeight: '3.5rem'
  },
  h2: {
    fontSize: '2rem',
    lineHeight: '3rem'
  },
  h3: textStyles.h500,
  h4: textStyles.h400,
  h5: textStyles.h300,
  h6: textStyles.h200
};

export type HeadingProps = ChakraHeadingProps & {
  faded?: boolean;
  variant?: HeadingVariant;
};

export function Heading(props: HeadingProps): JSX.Element {
  const { faded = false, variant = 'h1', ...rest } = props;
  const as = (variant?.toString() as HeadingVariant) || 'span';

  return (
    <ChakraHeading
      role="heading"
      as={as}
      {...variantsHandler[variant as HeadingVariant]}
      color={faded ? 'palette_gray.60' : 'inherit'}
      {...rest}
    />
  );
}

export const HeadingTheme = defineStyleConfig({
  baseStyle: {
    margin: 0,
    padding: 0,
    fontWeight: 'bold'
  }
});
